<bootstrap-popup [id]="id" [displaySubject]="displaySubject" 
	[title]="'Choix du motif de refus'" [modalSize]="'modal-lg'">
	
	<div class="form-group row">
		<label class="control-label col-md-2 plus-half">N° accès</label>
		<div class="col-md-8 plus-half">
			<span>{{ getNumeroAcces() }}</span>
		</div>
	</div>	
	<div class="form-group row">
		<label class="control-label col-md-2 plus-half">Motif de refus</label>
		<div class="col-md-8 plus-half">
			<select
				name="motifRefus" id="motifRefus"
				class="form-control"
				style="width: 18em; display: inline; padding-top: 3px;"
				[(ngModel)]="motifRefus" >
				<option [ngValue]="null">&nbsp;</option>
				<option *ngFor="let option of (motifsRefus$ | async)" [ngValue]="option">{{ option.libelle }}</option>
			</select>
		</div>
	</div>

	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button type="button" class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
				<button type="button" class="btn btn-danger" style="margin-right: 10px" 
					(click)="onAnnulationRequested()" [disabled]="!motifRefus">
					Refuser
				</button>
			</div>
		</div>
	</div>

</bootstrap-popup>
